import styled from "@emotion/styled"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "src/components"
import { DealershipListTableHead } from "./DealershipListTableHead"
import { headSortingItems } from "./headSortingItems.const"

export const DealershipListSkeleton = () => (
	<>
		<StyledSkeletonHeading size="sm" $width="80px" />
		<Skeleton.Table
			caption="Dealership List"
			tableHead={<DealershipListTableHead items={headSortingItems} />}
			columns={5}
			rows={5}
			layout="fixed"
		/>
	</>
)

const StyledSkeletonHeading = styled(Skeleton.Heading)`
	margin: 0 0 ${spacingStaticSm};
`
